const tryMe = (object) => {
  return object || {};
};

export default tryMe;
